import ConfirmCodePage from './ConfirmCodePage';

export default ConfirmCodePage;


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmCodePage/index.js